import { configureStore } from "@reduxjs/toolkit"
import cartReducer from "./slices/cartSlice"
import urlReducer from "./slices/urlSlice"
import checkoutDraftReducer from "./slices/checkoutDraftSlice"

export const store = configureStore({
	reducer: {
		cart: cartReducer,
		url: urlReducer,
		checkoutDraft: checkoutDraftReducer
	}
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
